/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./MonthlyClassTable.vue?vue&type=template&id=42dcb32c&scoped=true&"
import script from "./MonthlyClassTable.vue?vue&type=script&setup=true&lang=js&"
export * from "./MonthlyClassTable.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./MonthlyClassTable.vue?vue&type=style&index=0&id=42dcb32c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42dcb32c",
  null
  
)

export default component.exports